import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable, Signal } from '@angular/core';
import {
  injectMutation,
  injectQuery,
  QueryClient,
  QueryKey,
} from '@tanstack/angular-query-experimental';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { TenantService } from './tenant.service';
import { Router } from '@angular/router';
import { MeetingEvent } from '../models/meetings.model';
import { DocumentsNeededAnalysis, PromptAnalysis } from '../models/meetingsAi.model';
import { BaseApiService } from './base.api.service';


@Injectable({ providedIn: 'root' })
export class MeetingAiService extends BaseApiService {
  private promptEvaluationKey: QueryKey = ['promptEvaluation'];
  private documentsNeededKey: QueryKey = ['documentsNeeded'];

  evaluatePrompt = injectMutation(() => ({
    retry: false,
    mutationFn: async (args: { prompt: string; }) => {
      const response = await firstValueFrom(
        this.httpClient.post<PromptAnalysis>(`${this.baseUrl}/api/ai/api/meeting/analyze`, {
          "prompt": args.prompt
        }, {
          withCredentials: true
        })
      );
      return response;
      // Parse the JSON string response into a PromptAnalysis object
      // return JSON.parse(response as unknown as string) as PromptAnalysis;
    },
    onSettled: () => this.queryClient.invalidateQueries({ queryKey: this.promptEvaluationKey }),
  }));

  searchDocumentsNeeded = injectMutation(() => ({
    retry: false,
    mutationFn: async (args: { prompt: string; themes: string[] }) => {
      const response = await firstValueFrom(
        this.httpClient.post<DocumentsNeededAnalysis>(`${this.baseUrl}/api/ai/api/meeting/findDocuments`, {
          "prompt": args.prompt,
          "themes": args.themes
        }, {
          withCredentials: true
        })
      );
      return response;
      // Parse the JSON string response into a PromptAnalysis object
      // return JSON.parse(response as unknown as string) as PromptAnalysis;
    },
    onSettled: () => this.queryClient.invalidateQueries({ queryKey: this.documentsNeededKey }),
  }));

  searchNews = injectMutation(() => ({
    retry: false,
    mutationFn: async (args: { prompt: string; }) => {
      const response = await firstValueFrom(
        this.httpClient.get<any>(`${this.baseUrl}/api/bff/ainews/suggestnews?userPrompt=` + args.prompt,
        {
          withCredentials: true
        })
      );
      return response;
      // Parse the JSON string response into a PromptAnalysis object
      // return JSON.parse(response as unknown as string) as PromptAnalysis;
    },
    // onSettled: () => this.queryClient.invalidateQueries({ queryKey: this.documentsNeededKey }),
  }));

}